import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { getFleetsQueryOptions } from '@/service/vpc/queryOptions';

export const Route = createFileRoute('/_authenticated/_account/fleets/$fleetId')({
  component: FleetLayout,
  errorComponent: ErrorBoundary,
  loader: async (opts) => {
    const fleetAccountId = opts.context.fleetAccountId;
    if (!fleetAccountId) {
      return; // Return early if no fleet account is selected yet
    }
    return opts.context.queryClient.ensureQueryData(getFleetsQueryOptions({ fleetAccountId }));
  },
});

function FleetLayout() {
  return <Outlet />;
}
